// import { useRef } from 'react';
import NavBar from 'components/NavBar';

import './App.css';

function App() {

  return (
    <div className="App">
      <NavBar/>
    
    </div>
  );
}

export default App;
